(function() { window.GUID_48d95cb5_51cd_4b23_aeef_979f54e20d30 = { getGuid: function() { return "48d95cb5-51cd-4b23-aeef-979f54e20d30"; } }; })();
var CS;
(function (CS) {
    let SmartResponse;
    (function (SmartResponse) {
        function Parse(ajaxResponse) {
            let smartResponse = { originalResponse: null, error: false, scripts: '', isFullView: false };
            let $ajaxResponse = $(ajaxResponse);
            if ($ajaxResponse.length == 0) {
                return smartResponse;
            }
            let $error = $ajaxResponse.find('#error-container');
            if ($error.length > 0) {
                smartResponse.error = true;
                smartResponse.originalResponse = $error[0].outerHTML;
                return smartResponse;
            }
            let $smartResponse = $ajaxResponse.filter('smartresponse');
            let $originalResponse = $ajaxResponse.filter('originalresponse');
            //Full View
            if ($originalResponse.length == 0) {
                let commonData = $ajaxResponse.find('#commondataserialized').data('val');
                CS.CommonData.Current.RefreshFromSmartResponse(commonData);
                smartResponse.isFullView = true;
                smartResponse.originalResponse = $ajaxResponse[0].outerHTML;
            }
            //Partial view and json
            else {
                let dataType = $originalResponse.data('type');
                if (dataType == 'json') {
                    smartResponse.originalResponse = JSON.parse($originalResponse[0].innerHTML);
                }
                else {
                    smartResponse.originalResponse = $originalResponse[0].innerHTML;
                }
                let $oldScripts = CS.DOM.$sectionMaster.find('.ajax-appended');
                $oldScripts.remove();
                let $scripts = $smartResponse.find('script');
                $scripts.addClass('ajax-appended');
                for (var i = 0; i < $scripts.length; i++) {
                    smartResponse.scripts += $scripts[i].outerHTML;
                }
            }
            return smartResponse;
        }
        SmartResponse.Parse = Parse;
    })(SmartResponse = CS.SmartResponse || (CS.SmartResponse = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-smart-response.js.map
